// extracted by mini-css-extract-plugin
module.exports = {"root":"📦FilterablePlantsList__root--2o7Vn","filterContainer":"📦FilterablePlantsList__filterContainer--3RcJF","sticky":"📦FilterablePlantsList__sticky--17Cqo"};